import {
  animate,
  AnimationEvent,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  output,
} from '@angular/core';
import { SafePipe } from '../../../Pipes/safe.pipe';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'mt-tooltip-template',
  templateUrl: './mt-tooltip-template.component.html',
  styleUrls: ['./mt-tooltip-template.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(`tooltip`, [
      state(`void`, style({ opacity: 0, transform: 'translateY(2px)' })),
      state(
        `show`,
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
      ),
      state(
        `hide`,
        style({
          opacity: 0,
          transform: 'translateY(2px)',
        }),
      ),
      transition(`* => show`, animate(`100ms ease-out`)),
      transition(`show => *`, animate(`250ms ease-in`)),
    ]),
  ],
  imports: [MatIconModule, SafePipe],
})
export class MtTooltipTemplateComponent {
  private cdr = inject(ChangeDetectorRef);

  public text: string;
  public html: string;
  public canClose: boolean;

  readonly hide = output<void>();

  private _state = `void`;
  animationEndCallback: () => void;

  get state(): string {
    return this._state;
  }

  set state(value: string) {
    this._state = value;
    this.cdr.detectChanges();
  }

  end(event: AnimationEvent): void {
    if (event.toState === `hide` && this.state === `hide`) {
      this.animationEndCallback?.();
    }
  }
}
